import type { ClientEnvironment } from "../clientEnv";
import { isOfficialApkEnvironment } from "../install/withdrawalOfficialAppPrompt/policy";

export const getRegistrationInstallPromptEligibility = (
  env: ClientEnvironment,
  installLink: string,
): { show: boolean; env?: ClientEnvironment } => {
  if (isOfficialApkEnvironment(env) || !installLink) {
    return { show: false };
  }

  return { show: true, env };
};
